
import { CITIES} from '../../shared/constants/location.constants';
import { Component, inject, OnInit, Input } from '@angular/core';
import { MyReservationService } from '../../shared/services/my-reservation.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
import {
  ID_LOGIN_TYPE,
  IMAGE_DEPT_NAME,
  LINE_URL,
} from '../../shared/constants/common.constants';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { DevService } from '../../shared/services/dev.service';
import {
  HealthCheckPlanResponse,
  Reminder,
  ReminderItem,
  PackageGroup,
  PackageInfo,
  PlanListItem,
  ExamItem,
  BookingInfo,
  ImageBookData,
  OptionItem,
  ModifyPersonalHeathCheckInfoRequest,
  ModifyBusinessHeathCheckInfoRequest,
  CancelAppointmentRequest,
} from '../../shared/interfaces/my-reservation.model';
import { NumberCommaPipe } from '../../pipes/number-comma.pipe';
import { API_PARAMS } from '../../shared/constants/api.constants';
import { ExamItemName } from '../../shared/interfaces/reserve-confirm-survey.model';
import { DuoActionDialogComponent } from '../../shared/components/dialogs/duo-action-dialog/duo-action-dialog.component';
import { TwDatePipe } from '../../pipes/tw-date.pipe';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { ModifyExamReportDialogComponent } from '../../shared/components/dialogs/modify-exam-report-dialog/modify-exam-report-dialog.component';
import { ModifyExamReportDialogModel } from '../../shared/interfaces/dialogs/modify-exam-report-dialog.model';
import { ModifyExamClothesDialogComponent } from '../../shared/components/dialogs/modify-exam-clothes-dialog/modify-exam-clothes-dialog.component';
import { ModifyExamClothesDialogModel } from '../../shared/interfaces/dialogs/modify-exam-clothes-dialog.model';
import { ModifyExamDietDialogComponent } from '../../shared/components/dialogs/modify-exam-diet-dialog/modify-exam-diet-dialog.component';
import { ModifyExamDietDialogModel } from '../../shared/interfaces/dialogs/modify-exam-diet-dialog.model';
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { STORAGE_KEY } from '../../shared/constants/store-key.constants';
import { BookDatetimeInfo, BusinessCheckupSettingsRequest, PersonalCheckupSettingsRequest } from '../../shared/interfaces/appointment-info.model';
import { ToastrService } from 'ngx-toastr';
import { BusinessExamInfo, BusinessPackageInfo, BusinessPlanRequest, ExamInfo, PackageDetail } from '../../shared/interfaces/reserve-loading.model';
import { AddExamInfo } from '../../shared/interfaces/reserve-add.model';
import { Decimal } from 'decimal.js';
import { CreateMemberRequest } from '../../shared/interfaces/set-password.model';
import { calculateAge } from '../../shared/utils/validator.util';
import { InputCompanyNoDialogComponent } from '../../shared/components/dialogs/input-companyNo-dialog/input-companyNo-dialog';
import { AddExamItem } from '../../shared/interfaces/appointment-confirm.model';
import { AppointmentInfoService } from '../../shared/services/appointment-info.service';
import { DialogHelperService } from '../../shared/services/dialog-helper.service';

/**
 * 會員中心我的預約組件
 */
@Component({
  selector: 'app-prepare-appointment',
  standalone: true,
  imports: [
    TranslatePipe,
    MatButton,
    NgOptimizedImage,
    NumberCommaPipe,
    MatIconButton,
    MatButtonToggleGroup,
    MatButtonToggle,
  ],
  templateUrl: './prepare-appointment.component.html',
  styleUrl: './prepare-appointment.component.scss',
})
export class PrepareAppointmentComponent {
  @Input() selectedTab: number = 0;

  myReservationService: MyReservationService = inject(MyReservationService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  translateService: TranslateService = inject(TranslateService);
  authService: AuthService = inject(AuthService);
  devService: DevService = inject(DevService);
  dialog: MatDialog = inject(MatDialog);
  router: Router = inject(Router);
  toastr: ToastrService = inject(ToastrService);
  appointmentInfoService: AppointmentInfoService = inject(AppointmentInfoService);
  dialogHelperService: DialogHelperService = inject(DialogHelperService);

  twDatePipe: TwDatePipe = new TwDatePipe();
  formatDatePipe: FormatDatePipe = new FormatDatePipe();

  protected readonly Number = Number;

  flowCode: string = ''; // 預約執行流程代號
  idNo: string = ''; // 身分證字號
  caseNo: string = ''; // 健檢編號
  chartNo: string = ''; // 病歷號
  name: string = ''; // 姓名
  cell: string = ''; // 使用者電話
  birthday: string = ''; // 生日
  gender: string = ''; // 性別
  healthCheckPlan?: HealthCheckPlanResponse; // 健檢方案
  diffDays: number = 0; // 目前時間與預約時間相差天數

  isEditItem: boolean = false; // 是否可修改檢項(來自API)

  activeReminders = new Set<ReminderItem>(); // 切換提醒是否收合

  showFullExamInfos: boolean = false; // 是否顯示完整檢項資訊
  selectedPackage: string = ''; // 選擇的健檢方案

  examNameGroupByDeptName: Map<string, string[]> = new Map<string, string[]>(); // 健檢項目依照科別分組
  addExamNameList: Array<string> = []; // 加選檢查名稱列表

  isShowSponsorAmt: boolean = false; // 是否顯示企業補助金額(來自API)
  isShowPrice: boolean = false; // 是否顯示企業套檢金額(來自API)
  healthCheckTime: string = ''; // 健檢時間(HTML顯示用)
  nutritionConsultationTime: string = ''; // 營養諮詢時間(HTML顯示用)
  isShowNutrition:boolean = true;//是否顯示營養諮詢
  imageItems: Array<{ imageExamName: string; imageBookDateTime: string }> = []; // 高階影像檢查項目名稱列表
  orgName: string = ''; // 健檢中心名稱
  deliveryType: string = ''; // 檢查報告領取方式
  
  reportLanguageNoDesc: string = ''; // 檢查報告語言NODESC
  reportLanguageUno: string = ''; // 檢查報告語言UNO
  clothesSizeNoDesc: string = ''; // 健檢服尺寸NODESC
  clothesSizeUno: string = ''; // 健檢服尺寸UNO
  breakfastNoDesc: string = ''; // 早餐選項NODESC
  breakfastUno: string = ''; // 早餐選項UNO
  lunchNoDesc: string = ''; // 午餐選項NODESC
  lunchUno: string = ''; // 午餐選項UNO

  contactAddress: string = ''; // 檢前資料地址(完整)
  contactZipCode: string = ''; // 檢前資料地址的郵遞區號

  reportAddress: string = '';// 檢查報告地址(完整)
  reportZipCode: string = ''; // 檢後報告地址的郵遞區號
  examReportAddress: string = ''; //html顯示:國內/國外+檢後地址

  recipient: string = ''; // 報告收件人
  recipientCell: string = ''; // 收件人手機號碼
  isShowRecipientCell: boolean = false; // 是否顯示收件人手機號碼
  companyNo:string = '';//企業代碼
  familyFlag:string = '';//身分別-員工本人/眷屬

  
  // deptName是否展開 { deptName: isOpen }
  isDeptNameOpen: Map<string, boolean> = new Map();

  isLoading: boolean = true;  // 載入狀態
  isEditLocked: boolean = false; // 是否鎖定編輯，防止極短時間內快速再次修改時資料來不及刷新

  isShowModifyAddExam: boolean = true; // 是否顯示修改鈕-調整檢項加選
  isShowCancelReservation: boolean = true;// 是否顯示修改鈕-取消預約
  isShowModifyContactAddress: boolean = true;  // 是否顯示修改鈕-檢前資料地址
  isShowModifyExamReport: boolean = true;   // 是否顯示修改鈕-檢後報告地址
  isShowModifyExamClothes: boolean = true;  // 是否顯示修改鈕-衣服尺寸
  isShowModifyDiet: boolean = true;  // 是否顯示修改鈕-餐食
  isShowModifyTime: boolean = true;  // 是否顯示修改鈕-健檢時間
  isShowReservation: boolean = false;// 是否顯示預約紀錄
  bookStatus: string = ''; // 預約狀態

  packagePrice: number = 0; // 套檢金額

  billAmt: number = 0; //總金額


  // 檢查是否為 UAT 環境
  isUatEnvironment: boolean = true;

  ngOnInit(): void {

    // 檢查環境配置
    const env = (window as any)?.env;
    // this.isUatEnvironment = env?.environment !== 'dev';
    // 取得登入信息(身分證字號、生日、姓名、病例號)
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    this.idNo = createMemberRequest?.idNo ?? '';
    this.chartNo = createMemberRequest?.chartNo ?? '';
    this.name = createMemberRequest?.name ?? '';
    this.cell = createMemberRequest?.cell ?? '' ;
    this.gender = createMemberRequest?.gender ?? '';
    this.birthday = createMemberRequest?.birthday ?? '';
    this.birthday = this.formatDatePipe.transform(this.birthday);

    // 取得預約紀錄及已完成健檢(CB-057)
    this.myReservationService
      .getAppointmentHistory(this.idNo)
      .subscribe(res => {
        this.flowCode = res.data?.flowCode ?? '';
        console.log('flowCode', this.flowCode);

        if (this.flowCode === '4' || this.flowCode === '5') {
          // 2025.12.30 因應需求變更:已報到this.flowCode === '5'的當天仍可看見預約紀錄
          // 2026.01.07取消個人150天內不可預約的限制(將不會有this.flowCode === '5')
          this.isShowReservation = true;

          // 已有預約資料(呼叫CB-007)，初始化預約資料
          this.myReservationService
            .getHealthCheckPlan(this.chartNo, this.idNo)
            .subscribe(res => {

              this.healthCheckPlan = res.data;
              console.log('healthCheckPlan', this.healthCheckPlan);
              //取得資料提供CB-016 request
              if (this.healthCheckPlan?.bookData == null) {
                this.isShowReservation = false; // 不顯示
                this.isLoading = false;
                this.isEditLocked = false; // 資料刷新完成後解除鎖定
                console.log("不顯示預約紀錄");
                console.log('進入CB-007後this.isLoading:', this.isLoading);
                return;
              } else {
                this.isShowReservation = true; // 顯示
                console.log("顯示預約紀錄");
              }
      
              this.packagePrice = Number(this.healthCheckPlan?.packageGroup?.packagePrice ?? '');
              this.billAmt = Number(this.healthCheckPlan?.packageGroup?.billAmt ?? '');

              // 等候端API更新後再開放
              this.isEditItem = this.healthCheckPlan?.isEditInfo.isEditExam ?? false; // 是否可修改檢項(來自API)

              this.caseNo = this.healthCheckPlan?.bookData.caseNo ?? '';
              //取得資料提供CB-019 request(在dialog可能被修改到的)
              this.reportLanguageUno = this.healthCheckPlan?.bookData?.language.uno ?? ''
              this.deliveryType = this.healthCheckPlan?.bookData.deliveryType ?? '';
              this.recipient = this.healthCheckPlan?.bookData?.recipient ?? '';
              this.recipientCell = this.healthCheckPlan?.bookData?.recipientCell ?? '';
              this.clothesSizeUno = this.healthCheckPlan?.bookData?.clothesSize.uno ?? '';
              this.breakfastUno = this.healthCheckPlan?.bookData?.breakfast.uno ?? '';
              this.lunchUno = this.healthCheckPlan?.bookData?.lunch.uno ?? '';
              this.companyNo = this.healthCheckPlan?.bookData.companyNo ?? '';
              this.familyFlag = this.healthCheckPlan?.bookData.familyFlag ?? '';

              console.log('caseNo', this.healthCheckPlan?.bookData.caseNo);
              // if (this.healthCheckPlan?.reminderList[0]) {
              //   this.activeReminders.add(
              //     this.healthCheckPlan?.reminderList[0]
              //   ); // 預設展開第一組提醒
              // }
              this.selectedPackage =
                this.healthCheckPlan?.packageGroup.packageName ?? '';

              // 取得檢項
              this.healthCheckPlan?.packageGroup.packageInfo.planList.forEach(
                (pkg: PlanListItem) => {
                  this.isDeptNameOpen.set(pkg.deptName, false); // 初始化deptName展開狀態

                  // 取得現有的檢查項目列表,如果不存在則建立空陣列
                  const existingExamNames = this.examNameGroupByDeptName.get(pkg.deptName) ?? [];

                  // 從當前檢項中提取檢查項目名稱
                  const newExamNames = pkg.examItemList.map(exam => exam.examName);

                  // 使用 Set 去除重複項目,然後轉回陣列
                  const uniqueExamNames = Array.from(new Set([...existingExamNames, ...newExamNames]));

                  console.log('科別:', pkg.deptName);
                  console.log('原有檢查項目:', existingExamNames);
                  console.log('新增檢查項目:', newExamNames);
                  console.log('合併後不重複項目:', uniqueExamNames);

                  if (this.healthCheckPlan?.dataType === '2') {
                    this.isShowSponsorAmt = this.healthCheckPlan?.isShowSponsorAmt ?? false;
                    this.isShowPrice = this.healthCheckPlan?.isShowPrice ?? false;
                  }

                  this.examNameGroupByDeptName.set(pkg.deptName, uniqueExamNames);
                  console.log('this.examNameGroupByDeptName:', this.examNameGroupByDeptName);
                }
              );

              // 取得加選檢項
              this.addExamNameList = this.healthCheckPlan?.packageGroup.packageInfo.addList.map(
                (examItemName: ExamItemName) => examItemName.examName
              ) ?? [];
              
              //存方案金額(提供給CB-069)
              const paymentAmount = Number(this.healthCheckPlan?.packageGroup.billAmt ?? 0);
              const sponsorAmt = this.healthCheckPlan?.packageGroup.sponsorAmt ?? 0;
              this.sharedStorageService.set('sponsorAmt',sponsorAmt.toString());
              this.sharedStorageService.set('paymentAmount',paymentAmount);

              this.bookStatus = this.healthCheckPlan?.bookStatus;

              // 取得健檢時間
              const timestamp = res.timestamp;// 現在時間(取API回傳時間)
              const bookDate = this.healthCheckPlan?.bookData.bookDate;
              const bookTime = this.healthCheckPlan?.bookData.bookTime;
              const bookingDateTimeText =
                Number(bookTime) < 1200
                  ? this.translateService.instant('my-reservation.morning')
                  : this.translateService.instant('my-reservation.afternoon');
              this.healthCheckTime =
                this.twDatePipe.transform(bookDate ?? '') +
                ' ' +
                bookingDateTimeText +
                bookTime?.replace(/^(\d{2})(\d{2})$/, '$1:$2');

                //計算距離健檢日天數
                const bookStatus =this.healthCheckPlan?.bookStatus;
                const now = new Date(timestamp);
                console.log('now:', now);

                if(bookDate === undefined) {
                  this.isShowReservation = false;
                }else{
                const year = parseInt(bookDate.substring(0, 4));
                const month = parseInt(bookDate.substring(4, 6)) - 1; // Months are 0-indexed
                const day = parseInt(bookDate.substring(6, 8));
                const book = new Date(year, month, day);

                const bookDateOnly = new Date(book.getFullYear(), book.getMonth(), book.getDate());
                const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const timeDiff = bookDateOnly.getTime() - nowDateOnly.getTime();
                this.diffDays = Math.round(timeDiff / (1000 * 60 * 60 * 24)); // 轉換為天數

                console.log('diffDays:', this.diffDays);
                console.log('bookDate:', bookDateOnly);
                console.log('nowDate:', nowDateOnly);

                // if (this.flowCode === '5') {
                // 2026.01.07取消個人150天內不可預約的限制(將不會有this.flowCode === '5')
                  // if (this.diffDays < 0) {
                  //   this.isShowReservation = false;
                  // } else if (this.diffDays === 0) {
                  //   this.isShowReservation = true;// 2025.12.30  因應需求變更:已報到的當天仍可看見預約紀錄
                  // }
                // }


                // 是否顯示修改鈕
                if (bookStatus === '8'|| bookStatus === '9'|| this.diffDays <= 0 ) {
                // 全部關閉
                this.isShowModifyAddExam = false; 
                this.isShowCancelReservation = false;
                this.isShowModifyContactAddress = false;
                this.isShowModifyExamReport = false;
                this.isShowModifyExamClothes = false;
                this.isShowModifyDiet = false;
                this.isShowModifyTime = false;
                // 特殊條件
                if (bookStatus === '3' && this.diffDays >= -3) {
                  // 已報到 → 檢後報告可修改
                  // this.isShowModifyExamReport = true; //2025.11.7因應業務作業流程異動而取消
                } else if (bookStatus === '1' && this.diffDays >= -30) {
                  // 未報到 → 健檢時間可修改
                  this.isShowModifyTime = true;
                } 

                console.log('diffDays:', this.diffDays);
                
              } else if (this.diffDays <= 1) {
                this.isShowModifyAddExam = false;
                this.isShowCancelReservation = false;
                this.isShowModifyContactAddress = false;
                this.isShowModifyTime = false;
                this.isShowModifyDiet = false;
                this.isShowModifyExamClothes = false;
              } else if (this.diffDays <= 3) {
                this.isShowModifyAddExam = false;
                this.isShowCancelReservation = false;
                this.isShowModifyContactAddress = false;
                this.isShowModifyExamReport = true;
                this.isShowModifyTime = false;
                this.isShowModifyDiet = false;
                this.isShowModifyExamClothes = false;
              } else if (this.diffDays <= 7) {
                this.isShowModifyAddExam = false;
                this.isShowModifyContactAddress = false;
                this.isShowCancelReservation = false;
                this.isShowModifyTime = false;
              }else if(this.diffDays<=10){
                this.isShowModifyAddExam = false;
                this.isShowModifyContactAddress = false;
                this.isShowCancelReservation = false;
                this.isShowModifyTime = false;
              } 
              else if (this.diffDays <= 14) {
                this.isShowModifyContactAddress = false;
              }
                }
              // 取得營養諮詢時間
              const nutBookDate =
                this.healthCheckPlan?.bookData.nutBookDate;
                const nutBookTime =
                this.healthCheckPlan?.bookData.nutBookTime;
                console.log('nutBookDate:',nutBookDate);
                if(!nutBookDate || nutBookDate.trim() === ''){
                  this.isShowNutrition = false;
                }
                console.log('this.isShowNutrition:',this.isShowNutrition);
              const nutBookingDateTimeText =
                nutBookTime ?
                Number(nutBookTime) < 1200
                  ? this.translateService.instant('my-reservation.morning')
                  : this.translateService.instant('my-reservation.afternoon')
                : '無';
              this.nutritionConsultationTime =
                this.twDatePipe.transform(nutBookDate ?? '') +
                ' ' +
                nutBookingDateTimeText +
                nutBookTime?.replace(/^(\d{2})(\d{2})$/, '$1:$2');

              // 取得高階影像檢查項目名稱列表
              // 測試資料
              // const imageItemsTest :ImageBookData[]= [
              //   {
              //       "imageExamItem": "R90034A0",
              //       "imageExamName": "640切心臟冠狀動脈電腦斷層造影",
              //       "imageBookDate": "20250722",
              //       "imageBookTime": "1330到3樓集合",
              //       "imageBookHospital":"中心醫院"
              //   }
              // ];

              this.imageItems=
              this.healthCheckPlan?.bookData.imageBookDataList
              // this.imageItems=imageItemsTest//測試資料(若要使用則需先註解上面那行)
                .map(item => {
                  if (item.imageBookDate && item.imageBookTime) {
                    
                    // 解析 imageBookTime，可能包含註解文字
                    const timeMatch = item.imageBookTime.match(/^(\d{4})(.*)$/);
                    const timeOnly = timeMatch ? timeMatch[1] : '';
                    const noteText = timeMatch ? timeMatch[2] : '';

                    let timeDisplay = '';
                    if (timeOnly) {
                      // 有四位數字時，顯示上午/下午和格式化時間
                      //imageBookDateTime: "1200我是測試"->轉成"下午12:00我是測試"
                      const periodText = Number(timeOnly) < 1200
                        ? this.translateService.instant('my-reservation.morning')
                        : this.translateService.instant('my-reservation.afternoon');
                      const formattedTime = timeOnly.replace(/^(\d{2})(\d{2})$/, '$1:$2');
                      timeDisplay = periodText + formattedTime + noteText;
                    } else {
                      // 沒有四位數字時，直接顯示原始文字
                      //imageBookDateTime: "我是測試"->轉成"我是測試"(不顯示上午/下午)
                      timeDisplay = item.imageBookTime;
                    }
                    // imageBookHospital若HIS未填寫會是undefined，如果是 undefined、null 或空字串前端則使用空字串
                    timeDisplay = (item.imageBookHospital ?? '') + ' ' + timeDisplay;

                    return {
                      imageExamName: item.imageExamName,
                      imageBookDateTime: this.twDatePipe.transform(item.imageBookDate) + ' ' + timeDisplay
                    };
                    
                    
                  } else {
                    return {
                      imageExamName: item.imageExamName,
                      imageBookDateTime: this.translateService.instant('my-reservation.someone-call-to-confirm-time')
                    };
                  }
                }) ?? [];
             

              // 取得健檢中心名稱
              this.orgName = `${this.healthCheckPlan?.bookData.orgName} (${this.healthCheckPlan?.bookData.orgAddress})`;
              
              const bookData = this.healthCheckPlan?.bookData;
              //取得檢前資料地址
              this.contactAddress = bookData?.contactAddress ?? '';
              // 取得檢查報告地址
              this.reportAddress = bookData?.deliveryAddress ?? '';
              if (
                bookData?.deliveryType ===
                API_PARAMS.DELIVERY_METHOD.DOMESTIC.code
              ) {
                this.examReportAddress =
                  API_PARAMS.DELIVERY_METHOD.DOMESTIC.name +
                  "<span class='doc-divider'>・</span>" +
                  this.reportAddress;
              } else if (
                bookData?.deliveryType ===
                API_PARAMS.DELIVERY_METHOD.FOREIGN.code
              ) {
                this.examReportAddress =
                  API_PARAMS.DELIVERY_METHOD.FOREIGN.name +
                  "<span class='doc-divider'>・</span>" +
                  this.reportAddress;
              }

              //取得收件人資料
              this.recipient= bookData?.recipient??'無';
              this.recipientCell = bookData?.recipientCell ?? '';
              
              //判斷收件人資料是否非本人
              const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
              if(this.recipient ===createMemberRequest?.name){
                this.isShowRecipientCell = false;
              }else{
                //若非本人則顯示收件人電話
                this.isShowRecipientCell = true;
              }

              // 取得檢查報告語言
              this.reportLanguageNoDesc =
                this.healthCheckPlan?.bookData?.language.noDesc ?? '';

              // 取得健檢服尺寸
              this.clothesSizeNoDesc =
                this.healthCheckPlan?.bookData?.clothesSize.noDesc ?? '';

              // 取得早餐選項
              this.breakfastNoDesc =
                this.healthCheckPlan?.bookData?.breakfast.noDesc ?? '';

              // 取得午餐選項
              this.lunchNoDesc = this.healthCheckPlan?.bookData?.lunch.noDesc ?? '';

              this.setSharedStorage();
              console.log('已存入shared storage');

              this.isLoading = false;
              this.isEditLocked = false; // 資料刷新完成後解除鎖定
              console.log('進入CB-007後this.isLoading:', this.isLoading);
             });

        } else{
          //this.flowCode == '0'，不顯示預約紀錄
          this.isLoading = false;
          this.isEditLocked = false; // 資料刷新完成後解除鎖定
          this.isShowReservation = false;
        }
      });
  }

  //地址轉換
  parseAddress(address: string) {
    // '台'開頭的地址改為'臺'開頭，增加比對成功率
    address = address.trim();
    if (address.startsWith('台')) {
      address = '臺' + address.slice(1);
    }
    for (const city of CITIES) {
      if (address.startsWith(city.cityName)) {
        const rest = address.slice(city.cityName.length); // 去掉縣市
        for (const area of city.areaList) {
          if (rest.startsWith(area.areaName)) {
            const detailAddress = rest.slice(area.areaName.length); // 去掉行政區

            return {
              cityName: city.cityName,
              cityEngName: city.cityEngName,
              areaName: area.areaName,
              areaEngName: area.areaEngName,
              zipCode: area.zipCode,
              address: detailAddress, // 剩下的地址
            };
          }
        }
      }
    }
    return null; // 沒找到
  }

  setSharedStorage(){
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    // 提供給會員中心[健康調查表]

    const contactAddress = this.parseAddress(this.healthCheckPlan?.bookData.contactAddress ?? '');
    const deliveryAddress = this.parseAddress(this.healthCheckPlan?.bookData.deliveryAddress ?? '');
    // bookingInfo->如果appointment-time初始化不是從這裡取得的話bookingInfo可以整個不要
    const bookingInfo = {
      checkupDate: {
        bookDate: this.healthCheckPlan?.bookData.bookDate ?? '',
        bookTime: this.healthCheckPlan?.bookData.bookTime ?? '',
      } as BookDatetimeInfo, 
      nutrition: {
        bookDate: this.healthCheckPlan?.bookData.nutBookDate ?? '',
        bookTime: this.healthCheckPlan?.bookData.nutBookTime ?? '',
      } as BookDatetimeInfo,
      imagingContact: '',
      orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
      preExamInfoDeliveryMethod: this.healthCheckPlan?.dataType === '1'//個人
        ? API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.INDIVIDUAL.code
        : API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.AGENT.code,
      deliveryMethod: this.healthCheckPlan?.bookData.deliveryType?? '',//檢查報告領取方式0：郵寄國內 ⇒ 一般(聯絡地址)（僅個人）9：郵寄國外 ⇒ 國際航空(郵資自付)（僅個人）2：承辦領取（僅企業）3：不須寄送（僅企業）
      city: contactAddress?.cityName ?? '',
      district: contactAddress?.areaName ?? '',
      zipCode: this.healthCheckPlan?.bookData.contactZipCode ?? contactAddress?.zipCode ?? '',
      address: contactAddress?.address,
      reportCity: deliveryAddress?.cityName ?? '',
      reportDistrict: deliveryAddress?.areaName ?? '',
      reportZipCode: deliveryAddress?.zipCode ?? '',
      reportAddress: deliveryAddress?.address ?? '',
      foreignAddress: this.healthCheckPlan?.bookData.deliveryType==='9' ? this.healthCheckPlan?.bookData.deliveryAddress ?? '':'',
      deliveryRecipient: this.healthCheckPlan?.bookData.recipient === createMemberRequest?.name ?'01':'02',
      recipient: this.healthCheckPlan?.bookData.recipient ?? '',
      recipientCell: this.healthCheckPlan?.bookData.recipientCell ?? '',
      email: '',
      language: this.healthCheckPlan?.bookData.language.uno ?? '',
      clothesSize: this.clothesSizeUno ?? '',
      breakfast: this.healthCheckPlan?.bookData.breakfast.uno ?? '',
      lunch: this.healthCheckPlan?.bookData.lunch.uno ?? '',
      dayType: '',
      empId: this.healthCheckPlan?.bookData.employeeId ?? '',
      packageNo: this.healthCheckPlan?.packageGroup.packageNo ?? '',
    };
    this.contactZipCode = this.healthCheckPlan?.bookData.contactZipCode ?? contactAddress?.zipCode ?? '';
    this.reportZipCode=deliveryAddress?.zipCode ?? '';
    this.sharedStorageService.set(STORAGE_KEY.BOOKING_INFO, bookingInfo ?? []);

    // userPlanRequest
    const userPlanRequest = {
      orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
      gender: this.gender,
      birthday: this.birthday,
      age: calculateAge(this.birthday).toString(),
      idNo: this.idNo,
      identityType: '0',//'0'為有身分證，'1'為UUID
      name: this.name,
      cell: '',
      email: '',
      telH: '',
      telO: '',
      zipCode: '',
      history: [],
      family: [],
      subjectiveSymptoms: [],
    };
    this.sharedStorageService.set(STORAGE_KEY.USER_PLAN_REQUEST, userPlanRequest ?? []);

    // examItemList
    const examItemList = this.healthCheckPlan?.packageGroup.packageInfo.planList.flatMap(planItem => 
      planItem.examItemList.map(exam => ({
        deptName: planItem.deptName,
        deptEName: planItem.deptEName,
        examName: exam.examName,
        examItem: exam.examItem,
        examPrice: new Decimal(exam.examPrice ?? '0'),
        examMemo: exam.examMemo ?? '',
        selectFlag: 1,
        isNecessary: true,
        isChoice: true
      }))
    );
    this.sharedStorageService.set(STORAGE_KEY.EXAM_ITEM_LIST, examItemList ?? []);

    // addExamItemList
    const addExamItemList = this.healthCheckPlan?.packageGroup.packageInfo.addList.map(exam => ({
      examName: exam.examName,
      examItem: exam.examItem,
      examMemo: exam.examMemo ?? '',
      discountedPrice: exam.examPrice,
      mutexInfos: [],
      isNecessary: false,
      isChoice: true,
      disable: false,
      examType: '',
      deptName: exam.deptName ?? '',
      deptEName: exam.deptEName ?? '',
      selectFlag: 1,
    }));
    this.sharedStorageService.set(STORAGE_KEY.ADD_EXAM_ITEM_LIST, addExamItemList ?? []);

    if(!this.isPersonal){
      //企業
      // 判斷健檢時段：根據 bookTime 判斷上午(1)或下午(2)
            const bookTime = this.healthCheckPlan?.bookData.bookTime ?? '';
            const bookPeriod = this.healthCheckPlan?.bookData.bookPeriod ?? Number(bookTime) < 1200 ? '1' : '2'; // 1：上午 2：下午//非顯示用，此為資料面資料，提供修改時API使用

            // 判斷是否有早餐和午餐
            const hasBreakfast = !!(this.healthCheckPlan?.bookData.breakfast?.uno);
            const hasLunch = !!(this.healthCheckPlan?.bookData.lunch?.uno);

            // 轉換 planList 為 BusinessPackageInfo 格式
            const deptList: Array<BusinessPackageInfo> = this.healthCheckPlan?.packageGroup.packageInfo.planList.map(planItem => ({
              deptName: planItem.deptName,
              deptEName: planItem.deptEName,
              examItemList: planItem.examItemList.map(exam => ({
                examItem: exam.examItem,
                examName: exam.examName,
                examMemo: exam.examMemo ?? ''
              }))
            })) ?? [];

            // 取得原始企業方案金額
            let businessPrice = Number(this.healthCheckPlan?.packageGroup.packagePrice) ?? 0;

            const businessSelectedPackage: PackageDetail = {
              packageNo: this.healthCheckPlan?.packageGroup.packageNo ?? '',
              packageName: this.healthCheckPlan?.packageGroup.packageName ?? '',
              price: businessPrice.toString() ?? '',
              dayType: this.healthCheckPlan?.packageGroup.dayType ?? '',
              bookPeriod: bookPeriod,
              hasBreakfast: hasBreakfast,
              hasLunch: hasLunch,
              deptList: deptList,
              examChooseList: [],
              groupChooseList: [],
            }
            this.sharedStorageService.set('businessSelectedPackage', businessSelectedPackage);

            const businessPlanRequest: BusinessPlanRequest = {
              orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
              companyNo: this.healthCheckPlan?.bookData.companyNo ?? '',
              gender: this.gender ?? '',
            };
            this.sharedStorageService.set('businessPlanRequest', businessPlanRequest);
    }

  }

  // 是否為個人健檢
  get isPersonal(): boolean {
    console.log('this.healthCheckPlan?.dataType:', this.healthCheckPlan?.dataType);
    if(this.healthCheckPlan?.dataType === '1'){
      console.log('是個人健檢');
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);
      return true;
    }else{
      console.log('是企業健檢');
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.ENTERPRISE);
      return false;
    }
  }


  // 檢查企業補助金額是否大於0
  get hasSponsorAmt(): boolean {
    const sponsorAmt = this.healthCheckPlan?.packageGroup?.sponsorAmt;
    console.log("轉數字sponsorAmt:",Number(sponsorAmt));
    return sponsorAmt ? Number(sponsorAmt) > 0 : false;
  }

  // 切換提醒是否收合
  toggleReminderActive(reminder: ReminderItem): void {
    if (this.activeReminders.has(reminder)) {
      this.activeReminders.delete(reminder);
    } else {
      this.activeReminders.add(reminder);
    }
  }

  // 檢查提醒是否收合
  isReminderActive(reminder: ReminderItem): boolean {
    return this.activeReminders.has(reminder);
  }

  // 切換顯示全部檢項
  toggleShowFullExamInfos(): void {
    this.showFullExamInfos = !this.showFullExamInfos;
  }

  // 取得健檢時間類型
  getDayTypeText(dayType?: string): string {
    console.log('dayType:',dayType);
    //2025.12.26 統一用dayType判斷半日檢/全日檢
     return dayType === API_PARAMS.DAY_TYPE.HALF_DAY.code
          ? API_PARAMS.DAY_TYPE.HALF_DAY.name
          : API_PARAMS.DAY_TYPE.FULL_DAY.name;
  }

  // 點擊"調整檢項"按鈕
  modifyExam() {
    const imageItems = this.healthCheckPlan?.bookData.imageBookDataList;
    // 判斷是否高階影像寄送簡訊
    if (imageItems && imageItems.length > 0) {
      this.sharedStorageService.set('hasImageBookData', true);
    }

    if (this.isEditItem === false) {
      const editLockDialog = this.dialog.open(SingleActionDialogComponent, {
        data: {
          title: this.translateService.instant(
            'my-reservation.lock-dialog-title'
          ),
          message: this.translateService.instant(
            'my-reservation.lock-dialog-subtitle'
          ),
          buttonText: this.translateService.instant(
            'common.button.i-understood'
          ),
          showCloseButton: false,
          action: () => {
            editLockDialog.close();
          },
        },
      });
      return;
    }

    const modifyExamDialog = this.dialog.open(DuoActionDialogComponent, {
      data: {
        title: this.translateService.instant(
          'my-reservation.modify-exam-title'
        ),
        message: `${this.translateService.instant('my-reservation.modify-exam-message')}<br/>${this.translateService.instant('my-reservation.modify-exam-warning')}`,
        leftButtonText: this.translateService.instant(
          'my-reservation.cancel-modify-exam'
        ),
        rightButtonText: this.translateService.instant(
          'my-reservation.confirm-modify-exam'
        ),
        leftButtonAction: () => modifyExamDialog.close(),
        rightButtonAction: () => {

          // 儲存原始套檢金額，方便給修改檢項判斷
          // 測試假資料
          if (this.sharedStorageService.get('reserveType') === '2') {
            // this.packagePrice = 21000;
            console.log('originalPackagePrice', this.packagePrice);
            this.sharedStorageService.set('originalPackagePrice', this.packagePrice);
          }

          this.sharedStorageService.set('reserveStep',4);
          this.sharedStorageService.set('selectedPackage',this.healthCheckPlan?.packageGroup.packageName ?? '');
          // 計算原始方案價格
          const originalPrice = this.healthCheckPlan?.packageGroup.packageInfo.planList.reduce((total, planItem) => {
            return total + planItem.examItemList.reduce((sum, exam) => {
              return sum + (Number(exam.examPrice) || 0);
            }, 0);
          }, 0) ?? 0;

          this.sharedStorageService.set('isUpdate','1');
          this.sharedStorageService.set('packagePrice', originalPrice.toString());
          this.setSharedStorage();//提供後續打API的request資料
          this.sharedStorageService.set('modifyType',"modifyExam");// 已預約後的修改項目，"time":改時間，"modifyExam":調整檢項
          this.router.navigate(['/healthcheck/reserve/additem']).then();
          modifyExamDialog.close();
        },
        showCloseButton: false,
      },
    });
  }

  // 點擊"取消預約"按鈕
  cancelReservation() {
    const cancelReservationDialog = this.dialog.open(DuoActionDialogComponent, {
      data: {
        title: this.translateService.instant(
          'my-reservation.cancel-reservation-dialog-title'
        ),
        message: this.translateService.instant(
          'my-reservation.cancel-reservation-dialog-message'
        ),
        leftButtonText: this.translateService.instant(
          'my-reservation.reserve-reservation'
        ),
        rightButtonText: this.translateService.instant(
          'my-reservation.cancel-reservation'
        ),
        leftButtonAction: () => cancelReservationDialog.close(),
        rightButtonAction: () => {
          // 取消預約CB-016
          console.log('取消預約caseNo:', this.healthCheckPlan?.bookData.caseNo);
          const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
          const isSendMail = this.healthCheckPlan?.bookData.imageBookDataList && this.healthCheckPlan?.bookData.imageBookDataList?.length>0 ? true : false
          const request: CancelAppointmentRequest = {
            caseNo: this.caseNo,
            isTemp: false, // 是否為暫存，固定帶false
            isSendImagingMail: isSendMail,
            isSendNutMail: this.healthCheckPlan?.bookData.nutBookDate ? true : false,
            companyNo: this.companyNo??'',
            personalData: {
              idNo: this.idNo,
              chartNo: this.chartNo,
              name: this.name,
              cell: createMemberRequest?.cell ?? '',
              email: createMemberRequest?.email ?? '',
            },
            bookData: {
              orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
              orgName: this.healthCheckPlan?.bookData.orgName ?? '',
              dayType: this.healthCheckPlan?.packageGroup.dayType ?? '',
              packageNo: this.healthCheckPlan?.packageGroup.packageNo ?? '',
              bookDate: this.healthCheckPlan?.bookData.bookDate ?? '',
              imageBookDataList: this.healthCheckPlan?.bookData.imageBookDataList?.map(item => ({
                examItem: item.imageExamItem,
                examName: item.imageExamName,
                bookDate: item.imageBookDate ?? '',
                bookTime: item.imageBookTime ?? '',
                bookHospital: item.imageBookHospital ?? '',
              })) ?? [],
              nutBookDataList: this.healthCheckPlan?.bookData.nutBookDate 
                ? [{
                    bookDate: this.healthCheckPlan.bookData.nutBookDate,
                    bookTime: this.healthCheckPlan.bookData.nutBookTime ?? '',
                  }] 
                : [],
            },
          };

          this.myReservationService.cancelAppointment(request).subscribe(res => {
            if (res.success) {
              this.toastr.success(
                  this.translateService.instant('my-reservation.modify-reservation-success')
                );
              cancelReservationDialog.close();
              this.sharedStorageService.clear();
              this.sharedStorageService.remove('myReservation');
              // 重新取得預約紀錄及已完成健檢(CB-057)讓頁面判別
              this.myReservationService.getAppointmentHistory(this.idNo).subscribe({
                next: (res) => {
                  this.flowCode = res?.data?.flowCode ?? '0';
                },
              });
              this.router.navigate(['/healthcheck']).then();//返回首頁
              // this.flowCode = '-1'; // 設定flowCode為-1表示已取消預約
            }else{
              this.toastr.error(
                  this.translateService.instant('my-reservation.modify-reservation-error')
                );
                cancelReservationDialog.close();
            }
          });
        },
        showCloseButton: false,
      },
    });
  }

  // 導向預約時間頁面
  navigateToAppointmentTime() {
    this.sharedStorageService.set('reserveStep',7);
          this.sharedStorageService.set('selectedPackage',this.healthCheckPlan?.packageGroup.packageName ?? '');
          // const paymentAmount = this.healthCheckPlan?.packageGroup.billAmt ?? '0';
          // this.sharedStorageService.set('packagePrice',paymentAmount);
          this.setSharedStorage();//提供後續打API的request資料
          this.sharedStorageService.set('modifyType',"modifyTime");// 已預約後的修改項目，"time":改時間，"modifyExam":調整檢項
    this.router.navigate(['/healthcheck/reserve/timeselect']).then();
  }

  // 導向預約地點頁面
  navigateToReserveLocation() {
    this.router.navigate(['/healthcheck/reserve/location']).then();
  }

  // 開啟修改檢查相關資料與報告Dialog
  openModifyExamReportDialog() {

    // 檢驗金額dialog - 待規格出來再打開 (若總金額 < 套檢金額)
    if (this.billAmt < this.packagePrice) {
      const priceDialog = this.dialog.open(SingleActionDialogComponent, {
        data: {
          title: this.translateService.instant('my-reservation.price-dialog'),
          message: this.translateService.instant('my-reservation.price-dialog-message'),
          buttonText: this.translateService.instant('common.button.i-understood'),
          showCloseButton: false,
          action: () => priceDialog.close(),
        },
      });
      return;
    }

    if(!this.isEditLocked){
      //防止極短時間內快速再次修改時資料來不及刷新
      this.isEditLocked = true;

    const bookData = this.healthCheckPlan?.bookData;
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    const contactAddress = this.parseAddress(bookData?.contactAddress ?? '');
    const deliveryAddress = this.parseAddress(bookData?.deliveryAddress ?? '');
    

    const modifyExamReportDialogRef = this.dialog.open(
      ModifyExamReportDialogComponent,
      {
        panelClass: 'modify-dialog',
        data: {
          city: contactAddress?.cityName ?? '',
          district: contactAddress?.areaName ?? '',
          address: contactAddress?.address ?? '',
          deliveryMethod:
            bookData?.deliveryType ??
            API_PARAMS.DELIVERY_METHOD.DOMESTIC.code,
          reportCity: deliveryAddress?.cityName ?? '',
          reportDistrict: deliveryAddress?.areaName ?? '',
          reportAddress: deliveryAddress?.address ?? '',
          deliveryRecipient: bookData?.recipient===createMemberRequest?.name?'01':'02',
          recipient: bookData?.recipient ?? '',
          recipientCell: bookData?.recipientCell ?? '',
          foreignAddress: bookData?.deliveryAddress ?? '',
          language: bookData?.language.uno ?? '',
          isShowModifyContactAddress : this.isShowModifyContactAddress,
          noticeSendType: this.healthCheckPlan?.bookData?.noticeSendType ?? '',
        },
      }
    );

    modifyExamReportDialogRef
      .afterClosed()
      .subscribe((result: ModifyExamReportDialogModel) => {
        if (!result) {
          this.isEditLocked = false; // 使用者取消修改時解除鎖定
          return;
        }
        console.log("result:",result);
        // 儲存更新後的預約資訊
        this.reportLanguageUno = result.language;
        this.reportLanguageNoDesc = result.languageNoDesc;
        this.contactZipCode = result.zipCode ? result.zipCode :this.contactZipCode;//檢前地址郵遞區號(若未變更則使用原資料)
        this.contactAddress = result.zipCode ? '' + result.city + result.district + result.address :this.contactAddress;//檢前完整地址(若未變更則使用原資料)
        this.reportZipCode = result.reportZipCode??'';//檢後地址郵遞區號
        this.deliveryType = result.deliveryMethod;
        const domesticAddress ='' + result.reportCity + result.reportDistrict + result.reportAddress;//檢後完整地址(國內)
        this.reportAddress = result.deliveryMethod===API_PARAMS.DELIVERY_METHOD.DOMESTIC.code 
          ? domesticAddress
          : result.foreignAddress ??'';//檢後完整地址(國外)
        // this.recipient = result.recipient ??'';
        // this.recipientCell = result.recipientCell??'0';//改在後面判斷是否本人
        
        if (
          this.deliveryType ===
          API_PARAMS.DELIVERY_METHOD.DOMESTIC.code
        ) {
          //html顯示的檢後地址
          this.examReportAddress =
            API_PARAMS.DELIVERY_METHOD.DOMESTIC.name +
            "<span class='doc-divider'>・</span>" +
            this.reportAddress;
        } else if (
          this.deliveryType ===
          API_PARAMS.DELIVERY_METHOD.FOREIGN.code
        ) {
          this.examReportAddress =
            API_PARAMS.DELIVERY_METHOD.FOREIGN.name +
            "<span class='doc-divider'>・</span>" +
            this.reportAddress;
        }

        //如果沒有收件人資訊就填本人的
        const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
        if(result?.deliveryRecipient === API_PARAMS.DELIVERY_METHOD.SELF.code){
          this.recipient = createMemberRequest?.name ?? '';
          this.recipientCell = createMemberRequest?.cell ?? '0';
          this.isShowRecipientCell = false;
        }else {
            this.recipient = result.recipient ??'';
            this.recipientCell = result.recipientCell??'0';
            this.isShowRecipientCell = true;
          }
          console.log("this.recipient:",this.recipient)
        //儲存修改預約內容
        this.modifyHeathCheckInfo();
        modifyExamReportDialogRef.close();
      });
    } else {
      // 資料未更新完，先不彈窗
      console.log("修改資料更新中，更新完畢後再開放下一次修改");
    }
  }

  // 開啟修改健檢服尺寸Dialog
  openModifyExamClothesDialog() {

    // 檢驗金額dialog - 待規格出來再打開 (若總金額 < 套檢金額)
    if (this.billAmt < this.packagePrice) {
      const priceDialog = this.dialog.open(SingleActionDialogComponent, {
        data: {
          title: this.translateService.instant('my-reservation.price-dialog'),
          message: this.translateService.instant('my-reservation.price-dialog-message'),
          buttonText: this.translateService.instant('common.button.i-understood'),
          showCloseButton: false,
          action: () => priceDialog.close(),
        },
      });
      return;
    }

    if(!this.isEditLocked){
      //防止極短時間內快速再次修改時資料來不及刷新
      this.isEditLocked = true;

    this.dialogHelperService
      .openModifyClothesDialog(this.healthCheckPlan, this.isPersonal, {
        caseNo: this.caseNo,
        idNo: this.idNo,
        companyNo: this.companyNo,
      })
      .subscribe((result) => {
        if (!result) {
          this.isEditLocked = false; // 使用者取消修改時解除鎖定
          return;
        }

        this.clothesSizeUno = result.clothesSize;
        this.clothesSizeNoDesc = result.clothesSizeNoDesc;

        this.modifyHeathCheckInfo();
      });
    } else {
      console.log("修改資料更新中，更新完畢後再開放下一次修改");
    }
  }

  // 開啟修改飲食Dialog
  openModifyDietDialog() {

    // 檢驗金額dialog - 待規格出來再打開 (若總金額 < 套檢金額)
    if (this.billAmt < this.packagePrice) {
      const priceDialog = this.dialog.open(SingleActionDialogComponent, {
        data: {
          title: this.translateService.instant('my-reservation.price-dialog'),
          message: this.translateService.instant('my-reservation.price-dialog-message'),
          buttonText: this.translateService.instant('common.button.i-understood'),
          showCloseButton: false,
          action: () => priceDialog.close(),
        },
      });
      return;
    }

    if(!this.isEditLocked){
      //防止極短時間內快速再次修改時資料來不及刷新
      this.isEditLocked = true;
    
      this.dialogHelperService
        .openModifyDietDialog(this.healthCheckPlan, this.isPersonal, {
          caseNo: this.caseNo,
          idNo: this.idNo,
          companyNo: this.companyNo,
        })
        .subscribe((result) => {
          if (!result) {
            this.isEditLocked = false; // 使用者取消修改時解除鎖定
            return;
          }

          this.breakfastUno = result.breakfast;
          this.breakfastNoDesc = result.breakfastDesc;
          this.lunchUno = result.lunch;
          this.lunchNoDesc = result.lunchDesc;

          this.modifyHeathCheckInfo();
        });
      } else {
        console.log("修改資料更新中，更新完畢後再開放下一次修改");
      }
      
  }

  // 報告寄送是否同資料袋寄送地址
  get isContactAddress(): boolean {
    //  2 承辦領取、3 統一給業務、99 其他或如果 reportSendType 為 9（郵寄國外），則不同資料袋寄送地址
    if (this.deliveryType === '9'||this.deliveryType === '99'||this.deliveryType === '2'||this.deliveryType === '3') {
      console.log("this.deliveryType:", this.deliveryType);
      console.log("不同資料袋寄送地址，isContactAddress: false");
      return false;
    }
   return this.reportAddress===this.contactAddress;
  }

  //修改預約資訊
  modifyHeathCheckInfo(){
    const bookData = this.healthCheckPlan?.bookData;
    const addList = this.healthCheckPlan?.packageGroup.packageInfo.addList.map(exam => ({
        examItem: exam.examItem,
        examName: exam.examName,
        examPrice: exam.examPrice,
      }));
      
    if (this.isPersonal) {
      // CB-019 個人修改預約資訊
      const request: ModifyPersonalHeathCheckInfoRequest = {
      caseNo: this.caseNo,
      personalData: {
        idNo: this.idNo,
        chartNo: this.chartNo,
        address: this.contactAddress ?? '',
        zipCode: this.contactZipCode ?? '',
        langu: this.reportLanguageUno ?? '',
      },
      examItemData: {
        addExamList: addList?.map(item => item.examItem) ?? [],
      },
      bookData: {
          orgNo: bookData?.orgNo ?? '',
          price: new Decimal(this.healthCheckPlan?.packageGroup.billAmt?.toString() ?? '0'),
          bookDate: bookData?.bookDate ?? '',
          bookTime: bookData?.bookTime ?? '',
          nutBookDate: bookData?.nutBookDate ?? '',
          nutBookTime: bookData?.nutBookTime ?? '',
          imagingContact: "",
          deliveryType: this.deliveryType,
          isContactAddress: this.isContactAddress,
          zipCode: this.deliveryType === API_PARAMS.DELIVERY_METHOD.DOMESTIC.code ? this.reportZipCode : '',
          deliveryAddress: this.reportAddress,
          recipient: this.recipient ? this.recipient : this.name ,
          recipientCell: this.recipient ? this.recipientCell ||'0' : this.cell ||'0',
          clothesSize: this.clothesSizeUno,
          breakfast: this.breakfastUno,
          lunch: this.lunchUno || '',
          },
          imageCalInfo: bookData?.imageBookDataList && bookData?.imageBookDataList?.length>0 ? true : false,
        };
      console.log('CB-019 request:', request);  
      this.myReservationService.modifyPersonalHeathCheckInfo(request).subscribe({
        next: (res) => {
          if (res.success) {
              //將更新資料存到shared storage
              this.setSharedStorage();
              //刷新資料(isEditLocked 於 ngOnInit 資料刷新完成後才解除)
              this.examNameGroupByDeptName.clear();
              this.ngOnInit();
              this.toastr.success(
                this.translateService.instant('my-reservation.modify-reservation-success')
              );
          }else{
            this.toastr.error(
                this.translateService.instant('my-reservation.modify-reservation-error')
              );
              //刷新資料(isEditLocked 於 ngOnInit 資料刷新完成後才解除)
              this.examNameGroupByDeptName.clear();
              this.ngOnInit();
          }
        },
        error: () => {
          // API 例外時立即解鎖，避免畫面永久卡住
          this.toastr.error(
            this.translateService.instant('my-reservation.modify-reservation-error')
          );
          this.isEditLocked = false;
        },
      });
    }else{
      // CB-072 企業修改預約資訊
      console.log("企業修改預約資訊");
      const examItemList = this.healthCheckPlan?.packageGroup.packageInfo.planList.flatMap(planItem =>
        planItem.examItemList.map(exam => ({
          examItem: exam.examItem,
          examName: exam.examName
        }))
      ) ?? [];
      const addList = this.healthCheckPlan?.packageGroup.packageInfo.addList.map(exam => ({
        examItem: exam.examItem,
        examName: exam.examName,
        examPrice: exam.examPrice,
      }));

      const request: ModifyBusinessHeathCheckInfoRequest = {
        caseNo: this.caseNo,
        personalData: {
          idNo: this.idNo,
          chartNo: this.chartNo,
          address: this.contactAddress ?? '',
          zipCode: this.contactZipCode ?? '',
          langu: this.reportLanguageUno ?? '',
        },
        examItemData: {
          examItemList: examItemList,
          addList: addList,
        },
        bookData: {
            orgNo: bookData?.orgNo ?? '',
            companyNo: this.healthCheckPlan?.bookData.companyNo ?? '',
            familyFlag: this.healthCheckPlan?.bookData.familyFlag ?? '',
            packageNo: this.healthCheckPlan?.packageGroup.packageNo ?? '',
            price: this.healthCheckPlan?.packageGroup.billAmt,
            bookDate: bookData?.bookDate ?? '',
            bookTime: bookData?.bookTime ?? '',
            nutBookDate: bookData?.nutBookDate ?? '',
            nutBookTime: bookData?.nutBookTime ?? '',
            imagingContact: "",
            deliveryType: this.deliveryType,
            isContactAddress: this.isContactAddress,
            zipCode: this.deliveryType === API_PARAMS.DELIVERY_METHOD.DOMESTIC.code ? this.reportZipCode : '',
            deliveryAddress: this.reportAddress,
            recipient: this.recipient ? this.recipient : this.name ,
            recipientCell: this.recipient ? this.recipientCell ||'0' : this.cell ||'0',
            clothesSize: this.clothesSizeUno,
            breakfast: this.breakfastUno,
            lunch: this.lunchUno || '',
            },
            imageCalInfo: bookData?.imageBookDataList && bookData?.imageBookDataList?.length>0 ? true : false,
          };
        console.log('CB-072 request:', request);
        this.myReservationService.modifyBusinessHeathCheckInfo(request).subscribe({
          next: (res) => {
            if (res.success) {
                //將更新資料存到shared storage
                this.setSharedStorage();
                //刷新資料(isEditLocked 於 ngOnInit 資料刷新完成後才解除)
                this.ngOnInit();
                this.toastr.success(
                  this.translateService.instant('my-reservation.modify-reservation-success')
                );
            }else{
              this.toastr.error(
                  this.translateService.instant('my-reservation.modify-reservation-error')
                );
                //刷新資料(isEditLocked 於 ngOnInit 資料刷新完成後才解除)
                this.ngOnInit();
            }
          },
          error: () => {
            // API 例外時立即解鎖，避免畫面永久卡住
            this.toastr.error(
              this.translateService.instant('my-reservation.modify-reservation-error')
            );
            this.isEditLocked = false;
          },
        });
    }
    
    
  }
  // 顯示檢項dialog
  showExamDialog(examInfo: ExamInfo | AddExamInfo | BusinessExamInfo) {
    const examDialog = this.dialog.open(SingleActionDialogComponent, {
      data: {
        title: examInfo.examName,
        message: examInfo.examMemo,
        buttonText: this.translateService.instant('common.button.i-understood'),
        showCloseButton: false,
        action: () => examDialog.close(),
      },
    });
  }

  
  // 取得方案內檢項資訊
  getExamInfoByName(examName: string): ExamInfo | AddExamInfo | BusinessExamInfo {
    const planExamInfo = this.healthCheckPlan?.packageGroup.packageInfo.planList
      .flatMap((pkg: PlanListItem) => pkg.examItemList)
      .find((exam: ExamItem) => exam.examName === examName);
    if (planExamInfo) {
      return {
        examName: planExamInfo.examName,
        examItem: planExamInfo.examItem,
        examMemo: planExamInfo.examMemo ?? '',
        examPrice: new Decimal(planExamInfo.examPrice ?? 0),
      } as ExamInfo;
    }
    const addExamInfo = this.healthCheckPlan?.packageGroup.packageInfo.addList.find(
      (exam: ExamItemName) => exam.examName === examName
    );
    if (addExamInfo) {
      return {
        examName: addExamInfo.examName,
        examItem: addExamInfo.examItem,
        examMemo: addExamInfo.examMemo ?? '',
        price: new Decimal(addExamInfo.examPrice ?? '0'),
      }
    }
    return {} as ExamInfo;
  }

  // 取得加選檢項價格
  getExamPriceByName(examName: string): string  {
    const addExamItem = this.healthCheckPlan?.packageGroup.packageInfo.addList.find(
      item => item.examName === examName
    );
    return addExamItem?.examPrice ?? '0';
  }

  //導轉到LINE
  handleToLine(): void {
    window.open(LINE_URL, '_blank');
  }

  protected readonly API_PARAMS = API_PARAMS;
  protected readonly CITIES = CITIES;
}
